import locale from "localization";

export const orderSummaryStatus = [
  { label: locale.processing, value: "processing" },
  { label: locale.forApproval, value: "for-approval" },
  { label: locale.forRevision, value: "for-revision" },
  { label: locale.canceled, value: "canceled" },
  { label: locale.rejected, value: "rejected" },
  { label: locale.forDelivery, value: "for-delivery" },
  { label: locale.delivered, value: "delivered" },
];
